import React from "react";
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
  EventDTO,
  useAppSelector,
} from "@hypexone/uicore";
import { isMobile } from "react-device-detect";
import EventMarketButton from "../../events/EventMarketButton";
import BetSlip from "../BetSlip";
import BookmakerBackAndLay from "./BookmakerBackAndLay";

interface BookmakerRowProps {
  exposureMap: any;
  cFactor: number;
  runner: BookmakerRunnerDTO;
  market: BookmakerDTO;
  eventData: EventDTO;
  index: number;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  getOpenBetsPLInArray: (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => number[];
  getTotalPL: (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => number[];
  hideLay?: boolean;
}

const BookmakerRow: React.FC<BookmakerRowProps> = ({
  exposureMap,
  cFactor,
  runner,
  market,
  eventData,
  index,
  setAddNewBet,
  setBetStartTime,
  getOpenBetsPLInArray,
  getTotalPL,
  hideLay = false,
}) => {
  const {
    bets,
    isOneClickBettingEnabled,
    // openBets
  } = useAppSelector((state) => state.betSlip);

  const disabledStatus = [
    "suspended",
    "closed",
    "suspended-manually",
    "ball_running",
  ];

const isGenieMarket = market?.marketName?.toLowerCase().includes("genie") || market?.customMarketName?.toLowerCase().includes("genie");

  return (
    <>
      {/* Sky paints bookmaker runner rows cream (#faf8d8). */}
      <tr className=" border-b  border-b-gray13 h-[43px] w-full bg-yellow1">
        <td className="text-start pl-2 w-[60%] md:w-[40%] h-[43px]">
          <div className="flex items-center gap-1 h-full pl-2">
            <div className="flex items-center h-full">
              <span className=" text-[12px] font-[700] font-sans">
              {isGenieMarket && runner?.runnerName?.includes(";")
                                  ? runner.runnerName.split(";").map((part, i) => (
                                    <div key={i} className="flex items-center gap-2">
                                      <div className="flex flex-col items-center shrink-0">
                                        <div className="w-px h-1.5 bg-blue4" />
                                        <div className="w-2 h-2 rounded-full bg-blue4 shrink-0" />
                                        <div className="w-px h-1.5 bg-blue4" />
                                      </div>
                                      <span>{part.trim()}</span>
                                    </div>
                                  ))
                                  : runner?.runnerName}
              </span>
              {getOpenBetsPLInArray(
                runner,
                market.marketId,
                market.marketName
              ).map((ret, idx2) =>
                ret !== null ? (
                  <span
                    key={idx2}
                    className={
                      ret >= 0 ? " text-[#1b891b] text-[11px] font-semibold pl-2 " : " text-[#ff3a3a] text-[11px] font-semibold pl-2 "
                    }
                  >
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
            <div>
              {bets.length > 0 && bets[0].amount > 0 ? (
                <div>
                  {getTotalPL(runner, market.marketId, market.marketName).map(
                    (ret, idx3) =>
                      ret && ret !== null ? (
                        <span
                          key={idx3}
                          className={
                            ret >= 0 ? " text-[#1b891b] " : " text-[#ff3a3a] "
                          }
                        >
                          {ret > 0
                            ? "+" + Number(ret).toFixed(2)
                            : Number(ret).toFixed(2)}
                        </span>
                      ) : null
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </td>
        <td
          className={hideLay ? "w-[40%] md:w-[30%] h-[43px]" : "w-[20%] md:w-[30%] h-[43px]"}
          colSpan={isMobile ? 1 : 3}
        >
          <div className="hidden md:flex h-full"
          style={{
            background: "linear-gradient(90deg, rgba(130, 183, 221, 0.15) 0%, rgba(130, 183, 221, 0.8) 65%)"
          }}
          >
            <EventMarketButton valueType="bookmakerOdds" oddType="back-odd" customBgColor="transparent" />
            <EventMarketButton valueType="bookmakerOdds" oddType="back-odd" customBgColor="transparent" />
            <BookmakerBackAndLay
              runner={runner}
              market={market}
              eventData={eventData}
              oddType="back-odd"
              disabledStatus={disabledStatus}
            />
          </div>
          <div className="flex md:hidden h-full">
            <BookmakerBackAndLay
              runner={runner}
              market={market}
              eventData={eventData}
              oddType="back-odd"
              disabledStatus={disabledStatus}
            />
          </div>
        </td>
        {!hideLay && (
          <td
            className="w-[20%] md:w-[30%] h-[43px] relative"
            colSpan={isMobile ? 1 : 3}
          >
            <div className="hidden md:flex h-full"
            style={{
              background: "linear-gradient(270deg, rgba(231, 170, 184, 0.15) 5%, rgba(231, 170, 184, 0.8) 60%)"
            }}
            >
              <BookmakerBackAndLay
                runner={runner}
                market={market}
                eventData={eventData}
                oddType="lay-odd"
                disabledStatus={disabledStatus}
              />
              <EventMarketButton valueType="bookmakerOdds" oddType="lay-odd" customBgColor="transparent" />
              <EventMarketButton valueType="bookmakerOdds" oddType="lay-odd" customBgColor="transparent" />
            </div>
            <div className="flex md:hidden h-full">
              <BookmakerBackAndLay
                runner={runner}
                market={market}
                eventData={eventData}
                oddType="lay-odd"
                disabledStatus={disabledStatus}
              />
            </div>
            {disabledStatus.includes(runner.status?.toLowerCase()) ||
            eventData?.eventSuspended === true ||
            market.suspend === true ? (
            <div
              className="absolute top-0 bottom-0 left-[-100%] w-[200%] bg-black bg-opacity-25 z-10 flex items-center justify-center pointer-events-none"
              key={"row-" + index + "cell-5"}
            >
              <span className="text-white text-[11px]">
                Suspended
              </span>
            </div>
          ) : null}
          </td>
        )}

      </tr>

      {!isOneClickBettingEnabled &&
        bets?.length > 0 &&
        bets?.[0]?.marketName === market.marketName &&
        bets?.[0]?.marketId === market.marketId &&
        bets?.[0]?.outcomeId === runner?.runnerId && (
          <tr>
            <td colSpan={hideLay ? 2 : 7}>
              <BetSlip
                eventData={eventData}
                setBetStartTime={(date) => setBetStartTime(date)}
                setAddNewBet={(val) => setAddNewBet(val)}
              />
            </td>
          </tr>
        )}
    </>
  );
};

export default BookmakerRow;
